import coreHelper from "@/utils/coreHelper";
import apiService from "./apiService";

const userService = {

    async search(searchModel) {
        try {
            const resp = await apiService.get(`internal-users/search`, searchModel, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async deleteUser(id) {
        try {
            const resp = await apiService.delete(`users/${id}/delete`, true);
            return resp.data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
    async getInfo(id) {
        try {
            const resp = await apiService.get(`users/${id}/get-info`, {}, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async getMyInfo() {
        try {
            const resp = await apiService.get(`users/get-my-info`, {}, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async changePass(payload) {
        try {
            const resp = await apiService.post(`users/change-password`, payload, true);
            return resp.data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request!" };
        }
    },
    async changePassWithCurrentPassword(payload) {
        try {
            const resp = await apiService.post(`users/change-password-with-current-pw`, payload, true);
            return resp.data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request!" };
        }
    },
    async save(user) {
        try {
            const resp = await apiService.post(`users/save`, user, true);
            return resp.data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request" }
        }
    },
    async searchGroups(searchModel) {
        try {
            const resp = await apiService.get(`users/search-user-groups`, searchModel, true);
            return resp.data;
        } catch {
            return [];
        }
    },
    async getFullGroupInfo(id) {
        try {
            const resp = await apiService.get(`users/${id}/get-group-info`, {}, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async getAllAccess() {
        try {
            const resp = await apiService.get(`users/get-all-access-list`, {}, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async saveGroup(group) {
        try {
            const resp = await apiService.post(`users/save-group`, group, true);
            return resp.data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request!" };
        }
    },
    async searchRoles(searchModel) {
        try {
            const resp = await apiService.get(`users/search-roles`, searchModel, true);
            return resp.data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request!" };
        }
    },
    async getRoleInfo(id) {
        try {
            const resp = await apiService.get(`users/${id}/get-role-info`, {}, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async saveRole(role) {
        try {
            const resp = await apiService.post(`users/save-role`, role, true);
            return resp.data;
        }
        catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async deleteRole(id) {
        try {
            const resp = await apiService.delete(`users/${id}/delete-role`, true);
            return resp.data;
        }
        catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async deleteGroup(id) {
        try {
            const resp = await apiService.delete(`users/${id}/delete-group`, true);
            return resp.data;
        }
        catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async getActiveUsers() {
        try {
            const resp = await apiService.get(`users/get-active-users`, {}, true);
            return resp.data;
        }
        catch {
            return { count: 0 };
        }
    }
};

export default userService;